import React, { useEffect, useState } from 'react'

import styles from '../component-styles/top-scrollbar.module.scss'

interface Props {
  children: any
}

export default function TopScrollbar({
  children,
}: Props): React.ReactElement | null {
  const [childWidth, setChildWidth] = useState(1198)

  useEffect(() => {
    if (typeof children === 'object' && children !== null && children.ref) {
      setChildWidth(children.ref.current.offsetWidth)
    }
  }, [children])

  const scrollTop = (e) => {
    e.target.nextElementSibling.scrollLeft = e.target.scrollLeft
  }

  const scrollMain = (e) => {
    e.target.previousElementSibling.scrollLeft = e.target.scrollLeft
  }

  return (
    <>
      <div className={styles.doubleScroll} onScroll={scrollTop}>
        <div className={styles.topScroll} style={{ width: `${childWidth}px` }}>
          &nbsp;
        </div>
      </div>
      <div className={styles.doubleScroll} onScroll={scrollMain}>
        {children}
      </div>
    </>
  )
}
